import type { CrremSettings, EnergyAnalysisSettingsChange } from "features/energy-analysis-dashboard/model/types";

import { Stack } from "@mui/material";
import { EnergyAnalysisTrendMethodControl } from "features/energy-analysis-dashboard/components/EnergyAnalysisTrendMethodControl";

import type { CrremPathwayCorrectionOption, CrremPathwayPartitionBy, CrremPathwayScale } from "../model/types";

import { CrremPathwayCorrectionControl } from "./CrremPathwayCorrectionControl";
import { CrremPathwayPartitionControl } from "./CrremPathwayPartitionControl";
import { CrremPathwayScaleControl } from "./CrremPathwayScaleControl";

type CrremPathwaySettingsFormProps = {
  correctionOptions: CrremPathwayCorrectionOption[];
  disabled?: boolean;
  onPartitionByChange: (value: CrremPathwayPartitionBy) => void;
  onScaleChange: (value: CrremPathwayScale) => void;
  onSettingsChange: EnergyAnalysisSettingsChange;
  onVisibleCorrectionIdsChange: (ids: string[]) => void;
  partitionBy: CrremPathwayPartitionBy;
  scale: CrremPathwayScale;
  settings: CrremSettings;
  visibleCorrectionIds: string[];
};

export const CrremPathwaySettingsForm = ({
  correctionOptions,
  disabled,
  onPartitionByChange,
  onScaleChange,
  onSettingsChange,
  onVisibleCorrectionIdsChange,
  partitionBy,
  scale,
  settings,
  visibleCorrectionIds,
}: CrremPathwaySettingsFormProps) => (
  <Stack className="w-full min-w-0 flex-col items-start gap-6">
    <CrremPathwayPartitionControl onChange={onPartitionByChange} value={partitionBy} />
    <CrremPathwayScaleControl onChange={onScaleChange} value={scale} />
    <CrremPathwayCorrectionControl
      onChange={onVisibleCorrectionIdsChange}
      options={correctionOptions}
      value={visibleCorrectionIds}
    />
    <EnergyAnalysisTrendMethodControl disabled={disabled} onChange={onSettingsChange} settings={settings} />
  </Stack>
);
